<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.61 11.82h2.62a1.9 1.9 0 00-.56-1.39 3.3 3.3 0 00-2.05-.56 3.34 3.34 0 00-2.12.6A2 2 0 007 12a2.19 2.19 0 00.62 1.62 3.28 3.28 0 002 .51 3.22 3.22 0 002-.51 2.07 2.07 0 00.61-1.62H9.61zM12.4 12v2H16a1 1 0 001-1 1 1 0 00-1-1zM16.93 10.88A.93.93 0 0016 10h-3.6v1.87h3.67a.94.94 0 00.86-.99z"/><path d="M21 19H3a1 1 0 01-1-1V6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1zm0-1zM3 6v12h18V6z"/></svg>